// extracted by mini-css-extract-plugin
export default {"logo":"NavMenu_logo__O2Nb6","userContainer":"NavMenu_userContainer__w+WVz"};